import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import type { DayType } from '../components/Month/Day';
import { envApiUrl } from './envApiUrl';

export interface RegistrationResponse {
  data: DayType[];
  earnedTotalMonth: number;
  workingDaysTotalMonth: number;
  workingHoursTotalMonth: number;
  flexitimeHoursTotalMonth: number;
  overtimeHoursTotalMonth: number;
  flexiTime: null | number;
}

export const useRegistrations = (year: number, month: number) => {
  return useQuery<RegistrationResponse, Error>({
    queryKey: ['useRegistrations', year, month],

    queryFn: () => {
      if (!year) {
        throw new Error('Year is required');
      }
      return axios
        .get<RegistrationResponse>(`${envApiUrl}/registrations/getregistrations`, {
          headers: {
            'Content-Type': 'application/json',
            year,
            month: !Number.isNaN(month) ? month : null,
          },
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'x-csrf-token',
        })
        .then((response) => {
          return response.data as RegistrationResponse;
        });
    },
  });
};
